export const MAIN_STEPS = 100;
export const UPDATE_DRIVER_LOCATION_THROTTLE_MS = 300;
